import {createSlice} from "@reduxjs/toolkit";
import {TestState} from "./types";

const initialState: TestState = {}

const xTestSlice = createSlice({
    name: "testSlice",
    initialState: initialState,
    reducers: {
        reset: (s, a) => { return initialState },
        overwrite: (s, a) => { return a.payload },

        setId: (s, a) => { s.id = a.payload }
    }
})

// export the actions to be `dispatched`
export const xTestActions = xTestSlice.actions
// export the slide (to be used in root-reducer)
export default xTestSlice